import api from "./api";
import { getFullLogoUrl } from "../utils/urlUtils";

export const userService = {
  async getAll(params = {}) {
    try {
      const response = await api.get("/users", { params });

      // Process users to add full avatar URLs
      if (response.data.users) {
        response.data.users = response.data.users.map((user) => ({
          ...user,
          avatar: getFullLogoUrl(user.avatar),
        }));
      }

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getById(id) {
    try {
      const response = await api.get(`/users/${id}`);

      // Process user to add full avatar URL
      if (response.data) {
        response.data.avatar = getFullLogoUrl(response.data.avatar);
      }

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async create(userData) {
    try {
      const response = await api.post("/users", userData);

      // Process user to add full avatar URL
      if (response.data) {
        response.data.avatar = getFullLogoUrl(response.data.avatar);
      }

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async update(id, userData) {
    try {
      const response = await api.put(`/users/${id}`, userData);

      // Process user to add full avatar URL
      if (response.data) {
        response.data.avatar = getFullLogoUrl(response.data.avatar);
      }

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async delete(id) {
    try {
      const response = await api.delete(`/users/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async toggleStatus(id) {
    try {
      const response = await api.patch(`/users/${id}/toggle-status`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async resetPassword(id, passwordData) {
    try {
      const response = await api.patch(
        `/users/${id}/reset-password`,
        passwordData
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getByCompany(companyId, params = {}) {
    try {
      const response = await api.get(`/users/company/${companyId}`, { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getStats(params = {}) {
    try {
      const response = await api.get("/users/stats", { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async uploadAvatar(id, avatarFile) {
    try {
      const formData = new FormData();
      formData.append("avatar", avatarFile);
      const response = await api.post(`/users/${id}/avatar`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      // Process response to add full avatar URL
      if (response.data) {
        response.data.avatar = getFullLogoUrl(response.data.avatar);
      }

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async deleteAvatar(id) {
    try {
      const response = await api.delete(`/users/${id}/avatar`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default userService;
